import Vue from 'vue';

export default () => ({
  // app: { ...appServices(Vue.$service) },
});
